import React from "react";

import { useNavigateToLink } from "../../../components/react/link";
import { VIEWS_OVERVIEW_PATH } from "../../../routes/Routes";
import { MainMenuItemLayout } from "../MainMenuItemLayout";

export interface ViewMenuOverviewItemProps {
	viewsCount: undefined | number;
}

export const ViewMenuOverviewItem: React.FC<ViewMenuOverviewItemProps> = ({ viewsCount, ...props }) => {
	const link = useNavigateToLink(VIEWS_OVERVIEW_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return (
		<MainMenuItemLayout
			data-testid="view-menu-overview"
			icon={
				viewsCount != null && (
					<span className="max-w-[18px] font-medium text-10/3 text-graphite-600" data-testid="state-label">
						{viewsCount}
					</span>
				)
			}
			label="All views"
			level={1}
			to={link}
			{...props}
		/>
	);
};
